import { render, staticRenderFns } from "./third_header.vue?vue&type=template&id=04931ffe&scoped=true"
import script from "./third_header.vue?vue&type=script&lang=js"
export * from "./third_header.vue?vue&type=script&lang=js"
import style0 from "./third_header.vue?vue&type=style&index=0&id=04931ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04931ffe",
  null
  
)

export default component.exports